import UserIcon from '@heroicons/react/outline/esm/UserIcon.js'
import { clsx } from 'clsx'

import { Space } from '@tribeplatform/gql-client/types'
import { analyticsNumberFormatter } from '@tribeplatform/react-components/Analytics/utils'
import { T } from '@tribeplatform/react-components/i18n'
import type { StaticField } from '@tribeplatform/react-components/Views'

interface Props {
  space: Space
  highlighted: boolean
  stretchX: string
  variant: StaticField['settings']['buttonVariant']
}
export const MembersCount = ({
  space,
  highlighted,
  stretchX,
  variant,
}: Props) => {
  const membersCount = space?.membersCount

  if (variant === 'icon') {
    return (
      <div
        className={clsx(
          'flex space-s-2 text-content-subdued items-center empty:hidden',
          highlighted && 'ring-2 rounded-sm ring-offset-surface ring-focused',
          stretchX,
        )}
      >
        <UserIcon className="h-5 w-5" />
        <span>{analyticsNumberFormatter(membersCount ?? '0')}</span>
      </div>
    )
  }

  return (
    <div
      className={clsx(
        'flex space-s-2 text-content-subdued items-center empty:hidden',
        highlighted && 'ring-2 rounded-sm ring-offset-surface ring-focused',
        stretchX,
      )}
    >
      {variant === 'iconText' && <UserIcon className="h-5 w-5" />}
      <span>
        <T
          defaultMessage="{members_count, plural, =0 {No {MEMBERS}} =1 {{members_count_text} {MEMBER}} other {{members_count_text} {MEMBERS}}}"
          id="SpacesListBlock.MembersCount"
          values={{
            members_count: membersCount ?? 0,
            members_count_text: analyticsNumberFormatter(membersCount ?? '0'),
          }}
        />
      </span>
    </div>
  )
}
